import React, { useState } from "react";
import {  Link } from "react-router-dom";




const Header = () => {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  const closeNavbar = () => {
    setIsNavbarOpen(false);
  };

  return (
    <div>
      
        <section id="header">
          <nav
            className="navbar navbar-expand-md navbar-light pt-2 pb-2 bg-white"
            id="navbar_sticky"
          >
            <div
              className="container-fluid"
              style={{ paddingLeft: 40, paddingRight: 40 }}
            >
              <Link
                to="/"
                className="text-black p-0 navbar-brand fw-bold text-black family_o me-4"
              >
                <img
                  src="assets/img/DFA.svg"
                  alt="Wedding Planner Logo"
                  style={{ height: "60px", width: "auto", marginRight: "10px" }}
                />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded={isNavbarOpen ? "true" : "false"}
                aria-label="Toggle navigation"
                onClick={toggleNavbar}
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className={`collapse navbar-collapse ${
                  isNavbarOpen ? "show" : ""
                }`}
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav mb-0 ms-auto">
                  <li className="nav-item">
                    <Link
                      className="nav-link active"
                      aria-current="page"
                      to="/"
                      onClick={closeNavbar}
                    >
                      Home
                    </Link>
                  </li>

                  {/* Services Section */}
                  <li className="nav-item dropdown position-static">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Services
                    </a>
                    <div
                      className="dropdown-menu w-100 mega-menu p-3"
                      aria-labelledby="navbarDropdown"
                    >
                      <div className="container-xl">
                        <div className="row mt-3">
                          <div className="col-md-3">
                            <Link to="/data-analytics" onClick={closeNavbar}>
                              <h6 className="col_yell">Data Analytics</h6>
                            </Link>
                            <Link to="/data-analytics">
                              <p>Insights from data-driven analysis.</p>
                            </Link>
                          </div>

                          <div className="col-md-3">
                            <Link to="/business-intelligence">
                              <h6 className="col_yell">
                                Business Intelligence
                              </h6>
                            </Link>
                            <Link
                              to="/business-intelligence"
                              onClick={closeNavbar}
                            >
                              <p>Visualize and strategize with data.</p>
                            </Link>
                          </div>

                          <div className="col-md-3">
                            <Link to="/data-engineering" onClick={closeNavbar}>
                              <h6 className="col_yell">Data Engineering</h6>
                            </Link>
                            <Link to="/data-engineering">
                              <p>Building reliable data infrastructure.</p>
                            </Link>
                          </div>

                          <div className="col-md-3">
                            <Link
                              to="/artificial-intelligence"
                              onClick={closeNavbar}
                            >
                              <h6 className="col_yell">
                                Machine Learning & AI
                              </h6>
                            </Link>
                            <Link
                              to="/artificial-intelligence"
                              onClick={closeNavbar}
                            >
                              <p>Smart automation with ML & AI</p>
                            </Link>
                          </div>
                          <hr />

                          <div className="col-md-3">
                            <Link
                              to="/software-development"
                              onClick={closeNavbar}
                            >
                              <h6 className="col_yell">Software Development</h6>
                            </Link>
                            <Link
                              to="/software-development"
                              onClick={closeNavbar}
                            >
                              <p>Customized software for business needs.</p>
                            </Link>
                          </div>

                          <div className="col-md-3">
                            <Link to="/apps-development" onClick={closeNavbar}>
                              <h6 className="col_yell">
                                Mobile Apps Development
                              </h6>
                            </Link>
                            <Link to="/apps-development" onClick={closeNavbar}>
                              <p>Innovative mobile apps for platforms.</p>
                            </Link>
                          </div>

                          <div className="col-md-3">
                            <Link
                              to="/resource-outsource"
                              onClick={closeNavbar}
                            >
                              <h6 className="col_yell">Resource Outsourcing</h6>
                            </Link>
                            <Link to="/resource-outsource">
                              <p>Efficient staffing for project success.</p>
                            </Link>
                          </div>

                          <div className="col-md-3">
                            <Link to="/training" onClick={closeNavbar}>
                              <h6 className="col_yell">Training</h6>
                            </Link>
                            <Link to="/training">
                              <p>Upskill teams with expert training.</p>
                            </Link>
                          </div>
                          <hr />

                          <div className="col-md-3">
                            <Link to="/it-support" onClick={closeNavbar}>
                              <h6 className="col_yell">IT Support</h6>
                            </Link>
                            <Link to="/it-support">
                              <p>
                                Secure, scalable, and reliable IT support for your enterprise.
                              </p>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  {/* Sectors Section */}
                  <li className="nav-item dropdown position-static">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Sectors
                    </a>
                    <div
                      className="dropdown-menu w-100 mega-menu p-3"
                      aria-labelledby="navbarDropdown"
                    >
                      <div className="container-xl">
                        <div className="row mt-3">
                          <div className="col-md-3">
                            <Link to="/banking" onClick={closeNavbar}>
                              <h6 className="col_yell">Banking</h6>
                            </Link>
                            <p>Data-driven solutions for banking services.</p>
                          </div>
                          <div className="col-md-3">
                            <Link to="/healthcare" onClick={closeNavbar}>
                              <h6 className="col_yell">Healthcare</h6>
                            </Link>
                            <p>Advanced analytics for healthcare innovation.</p>
                          </div>
                          <div className="col-md-3">
                            <Link to="/retail" onClick={closeNavbar}>
                              <h6 className="col_yell">Retail</h6>
                            </Link>
                            <p>Enhancing the retail experience with data.</p>
                          </div>
                          <div className="col-md-3">
                            <Link to="/insurance" onClick={closeNavbar}>
                              <h6 className="col_yell">Insurance</h6>
                            </Link>
                            <p>Transforming the insurance industry with AI.</p>
                          </div>

                          <hr />
                          <div className="col-md-3">
                            <Link to="/education" onClick={closeNavbar}>
                              <h6 className="col_yell">Education</h6>
                            </Link>
                            <p>Revolutionizing education with technology.</p>
                          </div>
                          <div className="col-md-3">
                            <Link to="/manufacturing" onClick={closeNavbar}>
                              <h6 className="col_yell">Manufacturing</h6>
                            </Link>
                            <p>Smart manufacturing with data and AI.</p>
                          </div>
                          <div className="col-md-3">
                            <Link to="/capital-markets" onClick={closeNavbar}>
                              <h6 className="col_yell">Capital Markets</h6>
                            </Link>
                            <p>Leveraging analytics for capital markets.</p>
                          </div>
                          <div className="col-md-3">
                            <Link to="/public-services" onClick={closeNavbar}>
                              <h6 className="col_yell">Public Services</h6>
                            </Link>
                            <p>Data solutions for efficient public services.</p>
                          </div>

                          <hr />
                          <div className="col-md-3">
                            <Link to="/consumer-goods" onClick={closeNavbar}>
                              <h6 className="col_yell">FMCG</h6>
                            </Link>
                            <p>
                              Optimizing the Fast-moving consumer goods industry
                              with data.
                            </p>
                          </div>
                          {/* <div className="col-md-3">
                            <Link to="/high-tech">
                              <h6 className="col_yell">High Tech</h6>
                            </Link>
                            <p>Innovation through high-tech data solutions.</p>
                          </div> */}
                          <div className="col-md-3">
                            <Link to="/pharmaceutical" onClick={closeNavbar}>
                              <h6 className="col_yell">Pharmaceutical</h6>
                            </Link>
                            <p>Advancing pharma with data-driven insights.</p>
                          </div>
                          {/* <div className="col-md-3">
                            <Link to="/media-entertainment">
                              <h6 className="col_yell">
                                Media & Entertainment
                              </h6>
                            </Link>
                            <p>
                              Transforming media with cutting-edge technology.
                            </p>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </li>

                  {/* Other Links */}
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/blogs"
                      onClick={closeNavbar}
                    >
                      Blogs
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/about"
                      onClick={closeNavbar}
                    >
                      About Us
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className="nav-link"
                      to="/contact"
                      onClick={closeNavbar}
                    >
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>

          
          
        </section>
      
    </div>
  );
};

export default Header;
